import React from 'react';

function SignInLink({ href }: { href: string }) {
  return (
    <p className="mt-8 text-center text-base text-retino-darkgrey">
      {gettext('Already have an account?')}{' '}
      <a href={href} className="font-semibold text-brand-500">
        {gettext('Sign in')}
      </a>
    </p>
  );
}

export default SignInLink;
